"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var supports = window.CSS && CSS.supports && CSS.supports("object-fit", "cover") && CSS.supports("object-position", "0 0");

var FittedImg = function FittedImg(_ref) {
  var alt = _ref.alt,
      fit = _ref.fit,
      height = _ref.height,
      position = _ref.position,
      src = _ref.src,
      style = _ref.style,
      width = _ref.width,
      restProps = _objectWithoutProperties(_ref, ["alt", "fit", "height", "position", "src", "style", "width"]);

  return supports ? _react2.default.createElement("img", _extends({}, restProps, {
    alt: alt,
    height: height,
    src: src,
    style: _extends({}, style, {
      objectFit: fit,
      objectPosition: position
    }),
    width: width
  })) : _react2.default.createElement("span", _extends({}, restProps, {
    "aria-label": alt,
    role: "img",
    style: _extends({}, style, {
      backgroundImage: "url(\"" + src + "\")",
      backgroundPosition: position,
      backgroundSize: fit.replace("fill", "100% 100%").replace("none", "auto"),
      display: "inline-block",
      height: isFinite(height) ? height + "px" : height,
      width: isFinite(width) ? width + "px" : width
    })
  }));
};

FittedImg.propTypes = {
  alt: _propTypes2.default.string,
  fit: _propTypes2.default.oneOf(["fill", "contain", "cover", "none"]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  position: _propTypes2.default.string,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

FittedImg.defaultProps = {
  fit: "fill",
  position: "50% 50%"
};

exports.default = FittedImg;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fitted-img/lib/FittedImg.js
// module id = 14
// module chunks = 0